var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('GoBack',{attrs:{"name":`隐私条款`,"type":2,"path":`/mobile/my`}}),_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"p-list"},_vm._l((_vm.list),function(cItem,cIndex){return _c('p',{key:cIndex,style:(`text-indent: ${cItem.indent ? '2em' : ''}; margin-bottom:${
          cItem.bottom ? '20px' : '0px'
        };`),domProps:{"innerHTML":_vm._s(cItem.name)}})}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }